import React from 'react';
import HorizontalScroll from '../../HorizontalScroll';
import FeaturedItem from './FeaturedItem';
import './styles.css';

const Featured = ({ data, hideSuburb, scroll }) => {
  return scroll ? (
    <HorizontalScroll
      className="BusinessesList__Featured__root"
      arrows
      data={data.map(({ ...props }, key) => (
        <FeaturedItem key={key.toString()} hideSuburb={hideSuburb} {...props} />
      ))}
    />
  ) : (
    data.map(({ ...props }, key) => (
      <FeaturedItem key={key.toString()} hideSuburb={hideSuburb} {...props} />
    ))
  );
};

export default Featured;
